import { render, staticRenderFns } from "./LoggedInMenu.vue?vue&type=template&id=f2f2b0ca&scoped=true&"
import script from "./LoggedInMenu.vue?vue&type=script&lang=js&"
export * from "./LoggedInMenu.vue?vue&type=script&lang=js&"
import style0 from "./LoggedInMenu.vue?vue&type=style&index=0&id=f2f2b0ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f2b0ca",
  null
  
)

export default component.exports